// import * as $ from 'jquery';

export function FancyboxDirective() {
  return {
    restrict: 'A',
    link: function () {
      jQuery('.fancybox').fancybox();
    },
  };
}
